import { useEffect, useState } from "react";
import axios from "axios";
import { DepartmentMap } from "../components/DepartmentMap";

export default function PublicCoverage() {
  const [data, setData] = useState(null);
  const [off, setOff] = useState(false);
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/public/coverage`).then((r) => setData(r.data)).catch(() => setOff(true));
  }, []);
  if (off) return <div className="min-h-screen grid place-items-center text-slate-500" data-testid="public-coverage-off">Carte indisponible.</div>;
  if (!data) return <div className="min-h-screen grid place-items-center text-slate-400">Chargement…</div>;
  return (
    <div className="min-h-screen bg-white p-6 max-w-4xl mx-auto" data-testid="public-coverage">
      <h1 className="font-display text-3xl font-extrabold tracking-tight">{data.company} — nos zones d&apos;intervention</h1>
      <p className="text-sm text-slate-600 mt-1 mb-6">{data.departments.map((d) => `${d.name} (${d.code})`).join(" · ")}</p>
      <DepartmentMap departments={data.departments} />
    </div>
  );
}
